const TOPICS = [{
  value: "1",
  label: "Recalls",
  slug: "recalls"
},
{
  value: "2",
  label: "Warranty",
  slug: "warranty"
},
{
  value: "3",
  label: "Infotainment & maps",
  slug: "infotainment-maps"
},
{
  value: "4",
  label: "Servicing",
  slug: "servicing"
},
{
  value: "5",
  label: "Updating my personal details",
  slug: "updating-my-personal-details"
},
{
  value: "6",
  label: "Changing my ownership status",
  slug: "changing-my-ownership-status"
},
{
  value: "8",
  label: "MyMazda",
  slug: "mymazda"
},
{
  value: "7",
  label: "Other",
  slug: "other"
}
]

export default TOPICS



// WEBPACK FOOTER //
// ./src/AtomicContainers/GetInTouch/TOPICS.js